import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  TeamShareMapModalContainer, type TeamShareMapModalContainerProps,
} from './teamShareMapModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    TeamShareMap: TeamShareMapModalContainerProps;
  }
}

modalRenderer.register('TeamShareMap', TeamShareMapModalContainer);
